import { fireGoogleAdsReadyCtaConversion, GOOGLE_ADS_READY_CTA_TIMEOUT_MS } from './analytics.js'

function ordinarySameTabActivation(event, link) {
  const target = link.getAttribute('target')

  return (
    link.tagName === 'A' &&
    Boolean(link.href) &&
    !event.defaultPrevented &&
    event.button === 0 &&
    !event.metaKey &&
    !event.ctrlKey &&
    !event.shiftKey &&
    !event.altKey &&
    (!target || target === '_self') &&
    !link.hasAttribute('download')
  )
}

function setLoginPending(link, pending) {
  for (const attribute of ['aria-busy', 'aria-disabled']) {
    if (pending) {
      link.setAttribute(attribute, 'true')
    } else {
      link.removeAttribute(attribute)
    }
  }

  link.querySelector('[data-ready-login-idle]')?.classList.toggle('hidden', pending)

  const pendingContent = link.querySelector('[data-ready-login-pending]')
  pendingContent?.classList.toggle('hidden', !pending)
  pendingContent?.classList.toggle('inline-flex', pending)
}

export function createGoogleAdsReadyCtaClickHandler({
  target = window,
  getFlowAttemptId,
  fireConversion = fireGoogleAdsReadyCtaConversion,
  timeoutMs = GOOGLE_ADS_READY_CTA_TIMEOUT_MS,
} = {}) {
  let pendingNavigation = null

  const clearPendingNavigation = () => {
    if (!pendingNavigation) return

    pendingNavigation.cancelled = true

    if (pendingNavigation.timerId !== null) {
      target.clearTimeout(pendingNavigation.timerId)
    }

    setLoginPending(pendingNavigation.link, false)
    pendingNavigation = null
  }

  const handleClick = event => {
    const link = event.target?.closest?.('[data-google-ads-ready-cta]')
    const cta = link?.dataset.googleAdsReadyCta

    if (!cta) return

    const flowAttemptId = getFlowAttemptId?.()

    if (cta !== 'login' || !ordinarySameTabActivation(event, link)) {
      try {
        fireConversion(cta, flowAttemptId, target)
      } catch (_error) {
        // Conversion reporting must never interrupt the native CTA action.
      }

      return
    }

    if (pendingNavigation) {
      if (pendingNavigation.navigated) {
        clearPendingNavigation()
        return
      }

      event.preventDefault()
      return
    }

    const navigation = {
      cancelled: false,
      link,
      navigated: false,
      timerId: null,
    }

    const navigate = () => {
      if (navigation.cancelled || navigation.navigated) return

      navigation.navigated = true

      if (navigation.timerId !== null) {
        target.clearTimeout(navigation.timerId)
        navigation.timerId = null
      }

      target.location.assign(link.href)
    }

    let sent = false

    try {
      sent = fireConversion(cta, flowAttemptId, target, navigate)
    } catch (_error) {
      // Leave navigation native when Google cannot accept the event.
    }

    if (!sent) return

    event.preventDefault()

    if (navigation.navigated) return

    setLoginPending(link, true)
    pendingNavigation = navigation
    navigation.timerId = target.setTimeout(navigate, timeoutMs)
  }

  return { clearPendingNavigation, handleClick }
}
